// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export default interface IMainInfoVersions {
  [versionId: string]: { version: string; date: string };
}
